// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"aa796835","114":"9692d582","503":"80979133","805":"9ddeda4f","836":"e24c727c"}[chunkId] + ".chunk.js";
};